import TimelineItemComponent from '@components/history/historyItem/body/timelimeItemComponent';
import { TicketStatus } from '@interfaces/ticket-status';
import AppContext from '@services/Context';
import { Badge, Col, Icon, Row, Timeline } from 'antd';
import React from 'react';

import I18n from '../../../../i18n';
import styled, { Theme } from '../../../../styled-components';

interface IProp {
    registers: any
    ticketStatus: TicketStatus
    ticketStatusLabel?: string
}

class HistoryItemComponent extends React.Component<IProp, {}> {

    renderTimelineItem(register: any, i: number) {
        return (
            <div key={i}>
                <TimelineItemComponent
                    id={i}
                    key={i}
                    register={register}
                    type={this.getTypeFromRegister(register)}
                />
            </div>
        )
    }

    getTypeFromRegister(register: any) {
        if (register.workflowEvent === null || register.workflowEvent === undefined) {
            return "process"
        }
        let type: number = register.workflowEvent.type;

        switch (type) {
            case 1:
                return "process"

            case 2:
                return "notification"

            default:
                return "errorOnType"
        }
    }

    getFinalDotElement(isComplete: boolean) {
        return (
            <Badge status="processing" className="goepik-timeline-number" />
        )
    }

    getFinalLabel(locale: any, customLabel?: string) {
        //console.log("custom label: ", customLabel);
        switch (this.props.ticketStatus) {
            case TicketStatus.OPENED:
                return I18n.l('global.ticket.status.started');

            case TicketStatus.CLOSED:
                return (
                    <h3 className="goepik-status-done">
                        <Icon type="check-circle" />
                        {I18n.l('common.status')} "{I18n.l('global.ticket.status.done')}"
                            </h3>
                )

            case TicketStatus.CANCELED:
                return (
                    <h3 className="goepik-status-error">
                        <Icon type="close-circle" />
                        {I18n.l('common.status')} "{I18n.l('global.ticket.status.error')}"
                            </h3>
                )

            case TicketStatus.IN_PROGRESS:
                if (customLabel != undefined) {
                    return (
                        <h3 className="goepik-status-in-progress">
                            <Icon type="clock-circle" />
                            {I18n.l('common.status')} "{this.props.ticketStatusLabel}"
                        </h3>
                    )
                } else {
                    return (
                        <h3 className="goepik-status-in-progress">
                            <Icon type="clock-circle" />
                            {I18n.l('common.status')} "{I18n.l('global.ticket.status.inprogress')}"
                        </h3>
                    )
                }

            default:
                return "Error on Ticket Status";
        }
    }

    render(): JSX.Element {
        return (
            <AppContext.Consumer>
                {({ locale, theme }) => (
                    <Row className="goepik-component-padding">
                        <Col sm={24} md={24} xl={24} className="goepik-component-padding">
                            <Row>
                                <Col sm={8} md={8} xl={8}>
                                </Col>
                                <Col sm={16} md={16} xl={16}>
                                    <GoEpikHistoryTimeline>
                                        <Timeline className="goepik-history-status" pending={this.getFinalLabel(locale, this.props.ticketStatusLabel)} pendingDot={this.getFinalDotElement(true)}>
                                            {
                                                this.props.registers.map((register: any, i: number) => {
                                                    return (
                                                        <div key={i}>
                                                            {/* {console.log("alo: ", register)} */}
                                                            {this.renderTimelineItem(register, i)}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </Timeline>
                                    </GoEpikHistoryTimeline>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )}
            </AppContext.Consumer>
        );
    }
};

const GoEpikHistoryTimeline = styled.div`
    

    .goepik-timeline-number{
        .ant-badge-count{
            background-color: ${Theme.primary.regular}!important;
            color: ${Theme.standard.white}!important;
            box-shadow: '0 0 0 1px #d9d9d9 inset!important'
        }
    }

    .goepik-history-status{
        .anticon{
            padding-right: 6px;
        }

        .goepik-status-in-progress{
            color: ${Theme.status.inProgress};
        }

        .goepik-status-done{
            color: ${Theme.status.done || '#28DCAA'};
        }

        .goepik-status-error{
            color: ${Theme.status.error};
        }

        .ant-timeline-item-pending{
            margin-left: 5.5px;
        }
    }
`;

export default HistoryItemComponent;
